/*
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */
export type AccessRouteConfig = {
  readonly defaultAccessRoute?: string;
  readonly details?: AccessRouteDetail[];
};

export type AccessRouteDetail = {
  readonly accessRoute: string;
  readonly locations: AccessRouteLocation[];
  readonly sizes: AccessRouteSize[];
  readonly defaultLocation?: string;
};

export type AccessRouteLocation = {
  readonly key: string;
  readonly label: string;
};

export type AccessRouteSize = {
  readonly key: string;
  readonly label: string;
  readonly color: string;
};

export type AccessRouteValue = {
  readonly accessRoute?: string;
  readonly side?: AccessRouteSide;
  readonly location?: string;
  readonly size?: string;
  readonly accessRoutePlacement?: AccessRoutePlacement;
};

export enum AccessRouteSide {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
  NONE = 'NONE',
}

export enum AccessRoutePlacement {
  IS_ALREADY_PLACED = 'IS_ALREADY_PLACED',
  VALUE_NOT_AVAILABLE = 'VALUE_NOT_AVAILABLE',
}

export type AccessRouteElementType = 'accessRoute';
